/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Profile_TextInputs */

const en_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a profile to download the subtitle file in.`)
};

const fr_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un profil pour télécharger le fichier de sous-titres.`)
};

const de_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie ein Profil aus, in dem die Untertiteldatei heruntergeladen werden soll.`)
};

const it_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un profilo in cui scaricare il file dei sottotitoli.`)
};

const ru_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите профиль, чтобы загрузить файл субтитров.`)
};

const es_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un perfil para descargar el archivo de subtítulos.`)
};

const zh_cn2_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择要下载字幕文件的配置文件。`)
};

const ja_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルをダウンロードするプロファイルを選択してください。`)
};

const hi_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया सबटाइटल फ़ाइल डाउनलोड करने के लिए एक प्रोफ़ाइल चुनें।`)
};

const pt_pt2_select_profile_text = /** @type {(inputs: Select_Profile_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um perfil para baixar o arquivo de legenda.`)
};

/**
* | output |
* | --- |
* | "Please select a profile to download the subtitle file in." |
*
* @param {Select_Profile_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_profile_text = /** @type {((inputs?: Select_Profile_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Profile_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_profile_text(inputs)
	if (locale === "de") return de_select_profile_text(inputs)
	if (locale === "it") return it_select_profile_text(inputs)
	if (locale === "ru") return ru_select_profile_text(inputs)
	if (locale === "es") return es_select_profile_text(inputs)
	if (locale === "zh-CN") return zh_cn2_select_profile_text(inputs)
	if (locale === "ja") return ja_select_profile_text(inputs)
	if (locale === "hi") return hi_select_profile_text(inputs)
	if (locale === "pt-PT") return pt_pt2_select_profile_text(inputs)
	return en_select_profile_text(inputs)
});